import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { DataInstance } from '@busy-human/gearbox';
import { Userspaces } from '@busy-human/k9-library';

type Props = {
	slots: DataInstance<Userspaces.Model>[]
	selectedUser?: DataInstance<Userspaces.Model> | undefined
}
type Emits = {
	(e: "update:selectedUser", slot: DataInstance<Userspaces.Model>): void
	(e: 'create-customer'):void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'customer-list',
  props: {
    slots: {},
    selectedUser: {}
  },
  emits: ["update:selectedUser", "create-customer"],
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const searchQuery = ref('');

//Change back to user.name.fullName onces its no longer an empty string
const filteredCustomers = computed<DataInstance<Userspaces.Model>[]>(() => props.slots.filter(user => {
	if(searchQuery.value) {
		const lowerQuery = searchQuery.value.toLowerCase();
		let searchFound = false;
		//Check Name (Can change to just user.name.full name later on)
		if(`${user.name.firstName.toLowerCase()} ${user.name.lastName.toLowerCase()}`.includes(lowerQuery))
		{searchFound = true;}
		//Check Email
		if(user.email.toLowerCase().includes(lowerQuery))
		{searchFound = true;};
		return searchFound;
	}
	return true;
}));

const __returned__ = { props, searchQuery, filteredCustomers, computed, ref, get DataInstance() { return DataInstance }, get Userspaces() { return Userspaces } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})